import { useMutation, useQueryClient } from '@tanstack/react-query';
import { customerServices } from '../services/customer.service';
import { toast } from 'react-hot-toast';

export const useUpdateKycStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: customerServices.updateKycStatus,
    onSuccess: (data, variables) => {
      toast.success('KYC status updated successfully');
      queryClient.invalidateQueries({ queryKey: ['customer', variables.customerId] });
      queryClient.invalidateQueries({ queryKey: ['customers'] });
      queryClient.invalidateQueries({ queryKey: ['customerStats'] });
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to update KYC status');
    },
  });
};
